/**
 * Market detection based on build-time REACT_APP_BRAND env var.
 * Each brand is built and deployed separately.
 */
export const getMarket = () => process.env.REACT_APP_BRAND || 'bg';

export const isLuxembourgMarket = () => getMarket() === 'lu';
export const isBulgariaMarket = () => getMarket() === 'bg';
export const isMWOMarket = () => getMarket() === 'mwo';
